import { mock, purchaseData } from '../../utils/mockdata';

var axios = require('axios');


export default {
    

    state: {
        purchases: [],
        selectedPurchase: {}
    }, 
    getters: {
        allPurchases: (state) => state.purchases,
        
        selectedPurchase: (state) => state.selectedPurchase
    },
    
    actions: {
        async fetchPurchases({commit}, contact) {

            await mock.onGet('/purchases', { params: { contactid: contact.id } }).reply(
                function(config) {
                    // console.log("purchases ... " + JSON.stringify(config))
                    return [200, {data: purchaseData}]
                }
               
              );
              
            await axios.get('/purchases', { params: { contactid: contact.id } } )
            .then(resp => {
                commit('setPurchases', resp.data.data),
                console.log("purchases fetched. > " + resp.data.data.length)
            });
            
        },
        async updatePurchase({commit}, purchase) {
            commit('updatePurchase', purchase)
        },
        putSelectedPurchase({commit}, purchase) {
            commit('setSelectedPurchase', purchase)
        },
        addNewPurchase({commit}, purchase) {
            commit('addNewPurchase', purchase)
        }, 
        deletePurchase({commit}, purchase) {
            commit('deletePurchase', purchase)
        }
    },
    mutations: {
        setPurchases: (state, purchases) => (state.purchases = purchases),
        setSelectedPurchase: (state, purchase) => (state.selectedPurchase = purchase),
        updatePurchase: (state, updpurchase) => {
            
            const index = state.purchases.findIndex(purchase => purchase.id == updpurchase.id)
            if (index !== -1) {
                state.purchasess.splice(index, 1, updpurchase)
            }
            // console.log("... > "+ JSON.stringify(updcontact))
        },
        addNewPurchase: (state, addpurchase) => {
            // console.log(JSON.stringify(state.purchases))
            // console.log(JSON.stringify(addpurchase))
            state.purchases.unshift(addpurchase)
        },
        deletePurchase: (state, delpurchase) => {
            const index = state.purchases.findIndex(purchase => purchase.id == delpurchase.id)
            if (index !== -1) {
                state.purchases.splice(index, 1)
            }
        }
    },
    
}

